var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "42px",
    viewBox: "0 0 47 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Connect-Colors-V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Metrics-Navigation-Copy-26",
    transform: "translate(-9.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-Copy-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-3",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5085902,13.257345 L39.5228232,13.1638025 C39.0806515,6.653621 33.1170263,5.52638639 30.4507118,9.12068687 L30.4507118,9.12163175 C29.7447552,7.13078234 28.6734851,5.29961664 27.2188729,3.84640051 C24.0724321,0.702804901 19.2891967,-0.971511728 14.0552498,1.23571381 C9.97891983,2.95443951 7.12662752,7.77140688 7.12662752,11.9553087 C7.12662752,12.447588 7.15604237,12.9323084 7.21297436,13.40758 L7.21297436,13.4047453 C4.23258508,14.164424 0.875495858,16.4255073 0.875495858,21.5334959 C0.875495858,21.6232589 0.876444725,21.7130219 0.878342457,21.8008952 C0.986513224,26.2635348 4.84175729,29.9457086 9.32420203,29.950433 L18.5661605,29.950433 L18.5661605,41.1991573 L30.7021614,29.950433 L38.4610417,29.950433 C39.4507093,29.9513778 40.4356326,29.7964185 41.3721637,29.477996 C43.6532385,28.7022545 46.9998902,26.6962871 46.9998902,21.6043614 C46.9998902,15.6280337 42.2204503,13.7212781 39.5085902,13.257345 Z",
    id: "Stroke-3",
    fill: "#00ABBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6412158,15.521074 L13.6444855,19.0407294",
    id: "Stroke-11",
    stroke: "#26303B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4460007,21.6205188 L21.6003505,16.2300129",
    id: "Stroke-13",
    stroke: "#26303B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.399968,18.8097078 L27.4041865,22.3284183",
    id: "Stroke-15",
    stroke: "#26303B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8235625,15.2443204 C33.5824453,14.94763 32.3337371,15.7091984 32.0357931,16.9450935 C31.737849,18.1819335 32.5026353,19.4244427 33.7447014,19.7211332 C34.9858186,20.0178236 36.2335779,19.2562552 36.531522,18.0203601 C36.829466,16.7835201 36.0646797,15.5410108 34.8235625,15.2443204 Z",
    id: "Stroke-17",
    stroke: "#26303B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0599276,21.4170874 C24.8188103,21.120397 23.5701022,21.8819654 23.2721582,23.1178605 C22.9742141,24.3547005 23.7390004,25.5972097 24.9810665,25.8939002 C26.2221837,26.1905906 27.469943,25.4290222 27.767887,24.1931271 C28.0658311,22.9562871 27.3010448,21.7137778 26.0599276,21.4170874 Z",
    id: "Stroke-19",
    stroke: "#26303B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0648103,11.9556867 C19.8236931,11.6589962 18.574985,12.4205646 18.2770409,13.6564598 C17.9790969,14.8932997 18.7438832,16.135809 19.9859492,16.4324994 C21.2270665,16.7291898 22.4748257,15.9676214 22.7727698,14.7317263 C23.0707138,13.4948863 22.3059275,12.2523771 21.0648103,11.9556867 Z",
    id: "Stroke-21",
    stroke: "#26303B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3010805,18.1284536 C11.0599633,17.8317632 9.81125514,18.5933316 9.5133111,19.8292267 C9.21536706,21.0660667 9.98015336,22.308576 11.2222194,22.6052664 C12.4633367,22.9019568 13.7110959,22.1403884 14.00904,20.9044933 C14.306984,19.6676533 13.5421977,18.4251441 12.3010805,18.1284536 Z",
    id: "Stroke-23",
    stroke: "#26303B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConnect);
export default __webpack_public_path__ + "static/media/ico_connect.c4b4b06e46441b63ec178326f8a9e34e.svg";
export { ForwardRef as ReactComponent };